import { useState, useEffect } from 'react'
import './slide-overlay.scss'
// redux
import { useSelector } from 'react-redux'
// hooks
import useUIActions from 'hooks/useUIActions'
import { useQRCareCenter } from 'hooks/contentful'
// components
import HabitsInside from 'modules/Habits/components/molecules/habits-inside/habits-inside'
import LiveInside from 'modules/Lives/components/molecules/live-inside/live-inside'
import NotificationInside from 'components/molecules/notification-inside/notification-inside'
import QRCareCenterInside from 'modules/CareNetwork/components/molecules/q-r-care-center-inside/q-r-care-center-inside'
import Portal from 'components/atoms/portal/portal'
import BlankPage from 'components/atoms/blank-page/blank-page'
// icons
import { ArrowLeftIcon } from 'components/atoms/icons/'
// types
import typesSlideOverlay from './types-slide-overlay'
import { SlideOnBoarding } from 'modules/Programs/components/organisms/slideOnboarding'

const SlideOverlay = () => {
	// redux
	const {
		elementsUI: {
			showOverlay: { open, element, id, template, showIconBack = true }
		}
	} = useSelector(state => state)

	// controls
	const [isOpen, setIsOpen] = useState(false)
	const [isClassControl, setIsClassControl] = useState('')

	// hooks
	const { hideOverlay } = useUIActions()

	// content
	const QRContent = useQRCareCenter()

	// actions
	const delayOpen = open => {
		open ? setIsClassControl('open') : setIsClassControl('close')
		setTimeout(() => {
			setIsOpen(open)
		}, 300)
	}

	// render
	const renderOverlay = {
		[typesSlideOverlay.habits]: <HabitsInside {...element} id={id} />,
		[typesSlideOverlay.live]: <LiveInside {...element} id={id} />,
		[typesSlideOverlay.notification]: <NotificationInside />,
		[typesSlideOverlay.QR]: <QRCareCenterInside type={id} element={element} content={QRContent} />,
		[typesSlideOverlay.programs]: <SlideOnBoarding />,
		default: <BlankPage />
	}

	useEffect(() => {
		delayOpen(open)

		return () => clearTimeout(delayOpen)
	}, [open])

	if (!open && !isOpen) return null

	return (
		<Portal id='overlay'>
			<main className={`o-slide-overlay ${isClassControl}`}>
				{showIconBack && (
					<button className='o-slide-overlay__close_btn' onClick={() => hideOverlay()}>
						<ArrowLeftIcon color='#fff' />
					</button>
				)}
				{renderOverlay[template] || renderOverlay.default}
			</main>
		</Portal>
	)
}

export default SlideOverlay
